/* eslint-disable import/prefer-default-export */
import DashSplitPane from './components/DashSplitPane.react';

export {
    DashSplitPane
};
